import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../../templates/Ui';
const StyledLabel = styled.span `
    display: block;
    color: ${color.gray.darkest};
    font-size: 15px;
    font-weight: 400;

    @media only screen and (min-width: 992px) {
        font-weight: 300;
    }
`;
const StatLabel = ({ children }) => (_jsx(StyledLabel, { children: children }));
export default StatLabel;
